import React, { FC } from "react";
import clsx from "clsx";
import { PProps } from "./P.props";

const P: FC<PProps> = React.memo(
	({
		size = "p1",
		type = "regular",
		children,
		className = "",
		dangerouslySetInnerHTML,
		...props
	}) => {
		const sizeClasses = {
			p1: "text-p1 minPhone:text-[20px] minPhone:leading-[25px] lg:text-[20px] lg:leading-[25px]",
			p2: "text-p2 minPhone:text-[18px] minPhone:leading-[24px] lg:text-[18px] lg:leading-[22px]",
			p3: "text-p3 minPhone:text-[16px] minPhone:leading-[24px] lg:text-[16px] lg:leading-[22px]",
			t1: "text-t1 minPhone:text-[14px] minPhone:leading-[18px] lg:text-[16px] lg:leading-[20px]",
			t2: "text-t2 minPhone:text-[12px] minPhone:leading-[14px] lg:text-[14px] lg:leading-[16px]",
		};

		const typeClasses = {
			light: "font-light font-mazzard",
			regular: "font-normal font-mazzard",
			medium: "font-medium font-mazzard",
			semibold: "font-semibold font-mazzard",
			bold: "font-bold font-mazzard",
		};

		const classnames = clsx(
			"cursor-default",
			sizeClasses[size],
			typeClasses[type],
			className
		);

		const contentProps = dangerouslySetInnerHTML
			? { dangerouslySetInnerHTML }
			: { children };

		return <p className={classnames} {...props} {...contentProps} />;
	}
);
export default P;
